// 프롬프트 라이브러리(목록·삽입·내 프롬프트 저장). 입력창 상태(input/setInput/textareaRef)를 주입받음.
import { useState } from 'react';
import { promptAPI } from '../../../api/client';
import { alertDialog, promptDialog, toast } from '../../../components/AppDialog';

export default function usePrompts({ input, setInput, textareaRef, applySkillTools, skillIdRef }) {
  const [showPrompts, setShowPrompts] = useState(false);
  const [promptList, setPromptList]   = useState([]);
  const [promptQ, setPromptQ]         = useState('');

  const openPrompts = async () => {
    setShowPrompts(true);
    try { const r = await promptAPI.list(); setPromptList(r.data || []); } catch (e) { /* */ }
  };
  const insertPrompt = (p) => {
    setInput((prev) => (prev && prev.trim() ? prev + '\n' + p.body : p.body));
    // 스킬이면 절차·검증을 서버가 지침으로 넣도록 id 를 남기고, 필요한 도구를 미리 켠다.
    if (skillIdRef) skillIdRef.current = p.is_skill ? p.id : null;   // 전송 시점에 읽힌다
    if (p.is_skill && Array.isArray(p.tools) && p.tools.length && applySkillTools) applySkillTools(p.tools);
    setShowPrompts(false);
    setTimeout(() => { try { textareaRef.current?.focus(); const el = textareaRef.current; if (el) { el.style.height = 'auto'; el.style.height = Math.min(el.scrollHeight, 126) + 'px'; } } catch (e) {} }, 0);
  };
  const saveMyPrompt = async () => {
    const t = await promptDialog('이 입력을 내 프롬프트로 저장합니다. 제목을 입력하세요.');
    if (!t || !t.trim()) return;
    if (!input.trim()) { alertDialog('저장할 입력 내용이 비어 있습니다.'); return; }
    try { await promptAPI.create({ title: t.trim(), body: input, scope: 'personal', category: '내 프롬프트' });
      toast('저장되었습니다.'); } catch (e) { alertDialog('저장에 실패했습니다.'); }
  };

  return { showPrompts, setShowPrompts, promptList, promptQ, setPromptQ, openPrompts, insertPrompt, saveMyPrompt };
}
